import { render, staticRenderFns } from "./sel-call.vue?vue&type=template&id=05c8077a&scoped=true&"
import script from "./sel-call.vue?vue&type=script&lang=js&"
export * from "./sel-call.vue?vue&type=script&lang=js&"
import style0 from "./sel-call.vue?vue&type=style&index=0&id=05c8077a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8077a",
  null
  
)

export default component.exports